import { UserInfo, UserRequest, UserRole } from '../types';
import apiClient from './apiClient';

const USERS_KEY = 'users';

const getUsers = async () => {
	const response = await apiClient.get<UserInfo[]>('/auth/users');
	return response.data;
};

const getUser = async (userUuid: string) => {
	const response = await apiClient.get<UserInfo>(`/auth/users/${userUuid}`);
	return response.data;
};

const updateUser = async (user: Partial<UserInfo>) => {
	const response = await apiClient.post<UserInfo>(`/auth/users`, user);
	return response.data;
};

const deleteUser = async (userUuid: string) => {
	const response = await apiClient.delete<string>(`/auth/users/${userUuid}`);
	return response.data;
};

const assignRolesToUser = async ({
	userUuid,
	roles,
}: {
	userUuid: string;
	roles: string[];
}) => {
	const response = await apiClient.post<null>(
		`/auth/users/${userUuid}/assignRoles`,
		{
			roles,
		},
	);
	return response.data;
};

const assignUseRoleToUser = async ({
	userUuid,
	roles,
}: {
	userUuid: string;
	roles: string[];
}) => {
	const response = await apiClient.post<null>(
		`/auth/users/${userUuid}/assignUseRoles`,
		{
			roles,
		},
	);
	return response.data;
};

const unassignRolesFromUser = async ({
	userUuid,
	roles,
}: {
	userUuid: string;
	roles: string[];
}) => {
	const response = await apiClient.post<null>(
		`/auth/users/${userUuid}/unassignRoles`,
		{
			roles,
		},
	);
	return response.data;
};

const addUser = async (user: UserRequest) => {
	const response = await apiClient.post<UserInfo>('/auth/users', user);
	return response.data;
};

const getUserRoles = async (userUuid: string) => {
	const response = await apiClient.get<UserRole[]>(
		`/auth/users/${userUuid}/roles`,
	);
	return response.data;
};

const activateRoleForUser = async (userUuid: string, role: string) => {
	const response = await apiClient.post(
		`/auth/users/${userUuid}/activateRole`,
		{
			role,
		},
	);
	return response.data;
};

const getCurrentUser = async () => {
	const response = await apiClient.get<UserInfo>('/auth/users/whoami');
	return response.data;
};

const UsersApi = {
	addUser,
	getUsers,
	getUser,
	deleteUser,
	assignRolesToUser,
	assignUseRoleToUser,
	unassignRolesFromUser,
	getUserRoles,
	activateRoleForUser,
	getCurrentUser,
	updateUser,
	USERS_KEY,
};

export default UsersApi;
